module.exports = __webpack_public_path__ + "static/media/anonymous-avatar.cb2cf13c.jpg";